import apiPath from "../../constants/api-path.constant";
import axios from "../../configs/axios-instances";

const feeRules = {
  fetchRules: ({ campaignId, success, error ,final}) => {
    const {
      feeRules: { fetchRules },
    } = apiPath;
    const path = fetchRules(campaignId);

    axios.getRequest({
      path,
      success,
      error,
      final
    });
  },
  addRule: ({ campaignId, payload, success, error ,final}) => {
    const {
      feeRules: { addRule },
    } = apiPath;
    const path = addRule(campaignId);
    axios.postRequest({
      path,
      payload,
      success,
      error,
      final
    });
  },
  updateRule: ({ campaignId, ruleId, payload, success, error,final }) => {
    const {
      feeRules: { updateRule },
    } = apiPath;
    const path = updateRule(campaignId, ruleId);
    axios.putRequest({
      path,
      payload,
      success,
      error,
      final
    });
  },
};

export default feeRules;
